import {
  GET_FACEBOOK_PROFILES,
  FILTER_PROFILES,
  CLEAR_FILTERED_PROFILES,
  SET_PROFILE,
  SELECTED_PROFILE,
  SELECTED_FACEBOOK_DETAILS,
  SET_TOGGLE_ADS,
  SET_DISPLAY_CONTENT,
  SET_CURRENT_TAB,
  STATS_FILTER,
  CAMPAIGN_DETAILS,
  ADSET_DETAILS,
  AD_DETAILS,
  CAMPAIGN_FILTERED,
  ADSET_FILTERED,
  AD_FILTERED,
  CAMPAIGN_SELECTED,
  ADSET_SELECTED,
  AD_SELECTED,
  GET_PROFILE_ERROR,
  FACEBOOK_PROFILES_ERROR,
} from "../../types";

const DashboardReducer = (state, action) => {
  switch (action.type) {
    case GET_FACEBOOK_PROFILES:
      return { ...state, profiles: action.payload };

    case FILTER_PROFILES:
      return {
        ...state,
        profiles_filtered: state.profiles.filter((profile) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return profile.profile_id.match(regex);
        }),
      };

    case CLEAR_FILTERED_PROFILES:
      return { ...state, profiles_filtered: null };

    case SET_PROFILE:
      return { ...state, profile_form: action.payload };

    case SELECTED_PROFILE:
      let id = "";
      let business_manager = "";
      let ad_account = "";
      let pixel = "";

      if (action.payload.bm_account && action.payload.bm_account.length > 0) {
        id = action.payload.bm_account[0].id
        business_manager = action.payload.bm_account[0].bm_account_id;
      }

      if (action.payload.ad_account && action.payload.ad_account.length > 0) {
        for (let x in action.payload.ad_account) {
          const each = action.payload.ad_account[x];
          const bm_id = each.bm_account_id;
          const ad_status = each.ad_account_status;

          // if (bm_id === business_manager && ad_status === 1) {
          if (bm_id === id) {
            ad_account = each.ad_account_id;

            if (each.pixels.length > 0) {
              pixel = each.pixels[0].id;
            }

            break;
          }
        }
      }

      return {
        ...state,
        selected_profile: action.payload,
        selected_fb_details: {
          id,
          business_manager,
          ad_account,
          pixel,
        },
      };

    case SELECTED_FACEBOOK_DETAILS:
      return { ...state, selected_fb_details: action.payload };

    case SET_TOGGLE_ADS:
      return { ...state, toggle_ads: action.payload };

    case SET_DISPLAY_CONTENT:
      return { ...state, display_content: action.payload };

    case SET_CURRENT_TAB:
      return { ...state, current_tab: action.payload };

    case STATS_FILTER:
      const filter = action.payload[0];
      const info = action.payload[1];

      if (filter === "stats_date_filter") {
        return {
          ...state,
          [filter]: {
            start_date: info[0],
            end_date: info[1],
            name: info[2],
          },
        };
      } else if (filter === "stats_delivery_filter") {
        const tab = info[0];
        const status = info[1];

        if (tab === "ALL") {
          return {
            ...state,
            [filter]: {
              Campaign: status,
              "Ad Set": status,
              Ad: status,
            },
          };
        } else {
          return { ...state, [filter]: { ...state[filter], [tab]: status } };
        }
      } else if (filter === "stats_name_filter") {
        const tab = info[0];
        const text = info[1];

        if (tab === "ALL") {
          return {
            ...state,
            [filter]: {
              Campaign: text,
              "Ad Set": text,
              Ad: text,
            },
          };
        } else {
          return { ...state, [filter]: { ...state[filter], [tab]: text } };
        }
      } else {
        return state;
      }

    case CAMPAIGN_DETAILS:
      return { ...state, campaign_stats: action.payload };

    case ADSET_DETAILS:
      return { ...state, adset_stats: action.payload };

    case AD_DETAILS:
      return { ...state, ad_stats: action.payload };

    case CAMPAIGN_FILTERED:
      return {
        ...state,
        campaign_filtered: state.campaign_stats.filter((camp) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return camp.name.match(regex);
        }),
      };

    case ADSET_FILTERED:
      return {
        ...state,
        adset_filtered: state.adset_stats.filter((adset) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return adset.name.match(regex);
        }),
      };

    case AD_FILTERED:
      return {
        ...state,
        ad_filtered: state.ad_stats.filter((ad) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return ad.name.match(regex);
        }),
      };

    case CAMPAIGN_SELECTED:
      return { ...state, campaign_selected: action.payload };

    case ADSET_SELECTED:
      return { ...state, adset_selected: action.payload };

    case AD_SELECTED:
      return { ...state, AD_SELECTED: action.payload };

    case GET_PROFILE_ERROR:
      return { ...state, facebook_errors: action.payload };

    case FACEBOOK_PROFILES_ERROR:
      return { ...state, profiles_error: action.payload };

    default:
      return state;
  }
};

export default DashboardReducer;